import { render } from "./mvt-weathercard.vue?vue&type=template&id=36c873ff"
import script from "./mvt-weathercard.vue?vue&type=script&lang=js"
export * from "./mvt-weathercard.vue?vue&type=script&lang=js"

import "./mvt-weathercard.vue?vue&type=style&index=0&id=36c873ff&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__